module.exports = __webpack_public_path__ + "../resources/images/letsgo-flap-0ae2dd7c4991f597c9a5b598a3c44653.png";